import { DataGrid, Popup } from "devextreme-react";
import { ToolbarItem } from "devextreme-react/cjs/popup";
import React, { useCallback, useMemo, useState } from "react";
import { useDataSource } from "../../../../contexts/dataSource";
import { getPropsDataGrid } from "../../../../utils/default-props";
import { Column, DataGridTypes } from "devextreme-react/cjs/data-grid";


export function EmploymentDocumentCheckListAddTemplate({ visible, setVisible, onHiding, addFromTemplate }) {

    const { dataSourceHR } = useDataSource()
    const [selecttedTemplate, setSelectedTemplate] = useState(undefined)

    const dbDocumentTemplateList = useMemo(() => dataSourceHR({
        loadUrl: "/api/EmployeeCheckListTemplate"
    }), [dataSourceHR])

    const handleSelectButtonClick = useCallback(() => {
        if (!selecttedTemplate) {
            alert("Lütfen kayıt seçiniz.")
            return
        }
        if (addFromTemplate)
            addFromTemplate(selecttedTemplate)

        setVisible(false)
    }, [selecttedTemplate, setVisible])

    const getSelectButtonOptions = useCallback(() => ({
        text: "Seç",
        icon: "check",
        onClick: handleSelectButtonClick
    }), [handleSelectButtonClick])

    const getCancelButtonOptions = useCallback(() => ({
        icon: 'close',
        stylingMode: 'contained',
        text: 'İptal',
        onClick: () => { setVisible && setVisible(false) },
    }), [setVisible]);


    const onFocusedRowChanged = useCallback((e: DataGridTypes.FocusedRowChangedEvent) => {
        const data = e.row.data;
        console.log(data)
        setSelectedTemplate(data)
        //const progress = data.Task_Completion ? `${data.Task_Completion}%` : '';

        // setTaskSubject(data.Task_Subject);
        // setTaskDetails(data.Task_Description);
        // setTaskStatus(data.Task_Status);
        // setTaskProgress(progress);
        // setFocusedRowKey(e.component.option('focusedRowKey'));
    }, []);

    return (
        <Popup
            showTitle
            title="Şablon Seçimi"
            visible={visible}
            onHiding={onHiding}
            hideOnOutsideClick={true}
            defaultWidth={600}
            defaultHeight={500}
        >
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getSelectButtonOptions()}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getCancelButtonOptions()}
            />
            <DataGrid
                {...getPropsDataGrid}
                dataSource={dbDocumentTemplateList}
                onFocusedRowChanged={onFocusedRowChanged}
            >
                <Column dataField="name" caption="Şablon Adı">
                </Column>

            </DataGrid>
        </Popup>
    )
}